import type { ListBuilderConfiguration } from '../types';

/**
 * Client List list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const CLIENT_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-client-lists-all',
			cacheTTL: 600000,
			name: 'All Client Lists',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'list-name',
					fields: [
						{
							id: 'name-field',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'client_list',
								idField: '_id',
							},
							dataConfig: {
								type: 'field',
								field: { fieldName: 'name', objectTable: 'client_list' },
							},
							styleConfig: {
								size: 'md',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-1',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: { size: 'md', colorRule: { type: 'default' } },
							displayStyle: 'line_break',
						},
						{
							id: 'description-field',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'description', objectTable: 'client_list' },
							},
							styleConfig: {
								size: 'xs',
								colorRule: { type: 'theme', themeColor: 'textSecondary' },
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h1', text: 'List Name' }],
					minWidth: 200,
					sortable: true,
					alignment: 'left',
					sortFields: [
						{ direction: 'ASC', fieldName: 'name', objectTable: 'client_list' },
					],
					widthConfig: { mode: 'flexible', preset: 'large' },
					verticalAlignment: 'top',
				},
				{
					id: 'client-count',
					fields: [
						{
							id: 'client-count-field',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'clientCount', objectTable: 'client_list' },
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'text',
						},
					],
					headers: [{ id: 'h2', text: '# Clients' }],
					sortable: true,
					alignment: 'center',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: 'clientCount',
							objectTable: 'client_list',
						},
					],
					widthConfig: { mode: 'fixed', width: 100 },
					verticalAlignment: 'top',
				},
				{
					id: 'created-date',
					fields: [
						{
							id: 'created-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: '_created_date',
									objectTable: 'client_list',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'theme', themeColor: 'textSecondary' },
							},
							displayStyle: 'date',
						},
					],
					headers: [{ id: 'h3', text: 'Created' }],
					sortable: true,
					alignment: 'left',
					sortFields: [
						{
							direction: 'DESC',
							fieldName: '_created_date',
							objectTable: 'client_list',
						},
					],
					widthConfig: { mode: 'fixed', width: 120 },
					verticalAlignment: 'top',
				},
				{
					id: 'actions',
					fields: [
						{
							id: 'add-client-action',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'action_button',
							displayConfig: {
								icon: 'faUserPlus',
								variant: 'secondary',
								callback: 'addClient',
							},
						},
						{
							id: 'edit-action',
							dataConfig: { type: 'custom_text', customText: 'Edit' },
							styleConfig: {
								size: 'sm',
								iconName: 'faPencil',
								variant: 'outline',
								colorRule: { type: 'theme', themeColor: 'secondary' },
							},
							displayStyle: 'button',
							link: {
								enabled: true,
								type: 'object',
								objectTable: 'client_list',
								idField: '_id',
							},
						},
						{
							id: 'delete-action',
							dataConfig: { type: 'custom_text', customText: '' },
							styleConfig: {
								size: 'sm',
								colorRule: { type: 'default' },
							},
							displayStyle: 'action_button',
							displayConfig: {
								icon: 'faTrash',
								variant: 'secondary',
								callback: 'delete',
							},
						},
					],
					headers: [{ id: 'h5', text: 'Actions' }],
					sortable: false,
					alignment: 'right',
					widthConfig: { mode: 'fixed', width: 150 },
					verticalAlignment: 'top',
				},
			],
			description: 'All client lists',
			defaultSortId: 'name-asc',
			requiredFields: [
				'client_list._id',
				'client_list.name',
				'client_list.description',
				'client_list.clientCount',
				'client_list._created_date',
			],
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: [],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/clients/lists/:id',
			objectLabel: 'Client List',
			objectTable: 'client_list',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'description', fieldLabel: 'Description' },
				{ fieldName: 'clientCount', fieldLabel: 'Client Count' },
				{ fieldName: '_created_date', fieldLabel: 'Created Date' },
			],
		},
	],
	tableSorts: [
		{
			id: 'name-asc',
			name: 'Name (A-Z)',
			fields: [
				{ direction: 'ASC', fieldName: 'name', objectTable: 'client_list' },
			],
			description: 'Sort lists by name',
		},
		{
			id: 'name-desc',
			name: 'Name (Z-A)',
			fields: [
				{ direction: 'DESC', fieldName: 'name', objectTable: 'client_list' },
			],
			description: 'Sort lists by name descending',
		},
		{
			id: 'client-count-desc',
			name: 'Most Clients',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'clientCount',
					objectTable: 'client_list',
				},
			],
			description: 'Sort by number of clients',
		},
		{
			id: 'created-desc',
			name: 'Newest First',
			fields: [
				{
					direction: 'DESC',
					fieldName: '_created_date',
					objectTable: 'client_list',
				},
			],
			description: 'Sort by creation date',
		},
	],
};
